import tippy, { Instance } from 'tippy.js'
import { useEvent, useState } from '@/hooks'
import { Loader } from '../loader'
import { constant } from './dropdownMenu.Constant'
import { selectors } from './dropdownMenu.Selector'

const CLASS_NAMES = 'graph-dropdown-menu-content relative z-99999'

type State = {
	instances: Instance[]
}

export const DropdownMenu = (() => {
	const { state, setState } = useState<State>({ instances: [] })

	const init = () => {
		destroy()
		const targets = selectors.getTargetSelectors()
		const { length } = targets
		if (length === 0) return

		for (let i = 0; i < length; i++) {
			const tippySelector = targets[i]
			const button = selectors.getHandleButtonSelector(tippySelector)
			const content = selectors.getContentSelector(tippySelector)
			const isGlobal = content.getAttribute(constant.attributes.global) === '1'
			if (!button || !content) continue

			const instance = tippy(button, {
				content: `<div class="${CLASS_NAMES}">${content.innerHTML}</div>`,
				theme: 'light',
				allowHTML: true,
				placement: 'bottom',
				trigger: 'click',
				interactive: true,
				appendTo: document.body,
				zIndex: 10,
				onMount(tippyInstance) {
					const tippyContent: HTMLElement | null = document.querySelector('.tippy-content .graph-dropdown-menu-content')
					if (!tippyContent) return

					const items = selectors.getContentItemSelector(tippyContent)
					const link = content.getAttribute(constant.attributes.link)

					if (items.length !== 0 && link) {
						addSaveHandler(tippyInstance, tippySelector, items, link, isGlobal)
					}
				},
			})

			setState({ instances: [...state.instances, instance] })
		}
	}

	const addSaveHandler = (
		tippyInstance: Instance,
		tippySelector: HTMLElement,
		items: NodeListOf<HTMLButtonElement>,
		link: string,
		isGlobal: boolean,
	) => {
		const { length } = items
		for (let i = 0; i < length; i++) {
			const button = items[i]
			if (!button) continue

			const value = button.getAttribute(constant.attributes.value)
			if (!value) continue

			useEvent(button, 'click').register(() => {
				if (isGlobal) {
					tippyInstance.hide()
					Loader.create(tippySelector, { absolute: true })
				}

				$.nette.ajax({
					type: 'POST',
					dataType: 'json',
					url: link,
					data: {
						value,
					},
					complete() {
						destroy()
						init()

						if (isGlobal) {
							Loader.destroy(tippySelector)
						}
					},
				})
			})
		}
	}

	const destroy = () => {
		const { instances } = state
		const { length } = instances
		if (length === 0) return

		for (let i = 0; i < length; i++) {
			const instance = instances[i]
			if (!instance) continue

			instance.destroy()
		}
	}

	return {
		init,
	}
})()
